  
 
 
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
    Import Field Template
    <button mat-icon-button (click)="closeImportTaskTemplate()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
    
  <!-- <mat-dialog-content> -->
   
    <div class="template-holder">
      <div class="left">
  
        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="OnSelectCategoryImportFieldTemp($event)" value="My Template">
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option>
            <mat-option value="Global">Global</mat-option>
          </mat-select>
        </mat-form-field>
  
        <div class="list" #categoryList>
          <ul>
            <li (click)="getTaskListThroughCategoryForImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }">All
            </li>
            <ng-container *ngFor="let stat of filteredTempCategoryList; let i = index">
              <li (click)="getTaskListThroughCategoryForImport(stat.ocrTemplateCategoryID, i+1)"
                [ngClass]="{'active': currentIndex == i+1 }"> {{ stat.ocrTemplateCategoryName }}</li>
            </ng-container>
          </ul>
  
        </div>
  
      </div>
      <div class="right">
  
        <div class="list">
  
          <div class="tempalteList">
            <table cellspacing="0" cellspadding="0" width="100%">
              <tr>
                <th>Template Name</th>
                <th class="actBtn">Action</th>
              </tr>
              <tr *ngFor="let template of  ImportTemplatesList"
                [ngClass]="{ 'active': template.templateID === TemplateIDImportTask}"
                [ngStyle]="{ 'background-color': template.templateID === TemplateIDImportTask ? '#e8f0fe' : 'transparent' }">
  
                <td class="formName">
                  {{template.tempalteName}}
                </td>
  
                <td>
                  <button mat-stroked-button color="primary" (click)="SelectTemplate(template)">Select</button>
                </td>
              </tr>
            </table>
            <div *ngIf="ShowNoRecordFoundTemplates" class="noRecordFound">No Record Found</div>
          </div>
  
        </div>
  
      </div>
    </div>
  
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeImportTaskTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="TemplateIDImportTask!=0"
        (click)="importTemplates()">
        Import
      </button>
    </mat-dialog-actions>

  <!-- </mat-dialog-content> -->
  
 

 
  

  

  




